/* eslint-disable @nx/enforce-module-boundaries */
import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@mybridge/ui';
import { forwardRef, useContext, useState } from 'react';
import { useForm } from 'react-hook-form';
import { DiskContext } from '../context';
import { DiskDirectoryTree } from '../directory-tree';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
export const DiskMoveMultipleFilesModal = forwardRef(({ ...props }, ref) => {
  const [selected, setSelected] = useState();
  const {
    moveMultipleFileFolder,
    selectedFiles,
    multiMoveDisc,
    moveMultipleFileFolderLoading,
  } = useContext(DiskContext);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const onSubmit = () => {
    const ids = selectedFiles;
    moveMultipleFileFolder({ ids, parent: selected?.id });
  };
  const { t } = useTranslator();
  return (
    <>
      <Modal size="2xl" {...multiMoveDisc}>
        <ModalOverlay />
        <ModalContent>
          <ModalCloseButton />
          <ModalHeader>
            <Text truncate maxW="64">
              {t('myDisk.moveFilesHere') || "Move files here to"}...
            </Text>
          </ModalHeader>
          <ModalBody maxH="70vh" overflowY="auto">
            <DiskDirectoryTree setSelectedItem={setSelected} />
          </ModalBody>
          <ModalFooter>
            <Button
              borderRadius="full"
              isLoading={moveMultipleFileFolderLoading}
              onClick={onSubmit}
              variant="primary"
            >
              {t('myDisk.move') || "Move"}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
});
